import { render, staticRenderFns } from "./ClientCharts.vue?vue&type=template&id=c77494b4&scoped=true&"
import script from "./ClientCharts.vue?vue&type=script&lang=ts&"
export * from "./ClientCharts.vue?vue&type=script&lang=ts&"
import style0 from "./ClientCharts.vue?vue&type=style&index=0&id=c77494b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77494b4",
  null
  
)

export default component.exports